import { render } from "./index.vue?vue&type=template&id=10b088c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=10b088c6&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=10b088c6&lang=scss"
script.render = render
script.__scopeId = "data-v-10b088c6"

export default script